interface IMenuGroupItem {
  key: string
  path: string
  icon: string
  title: string
}
interface IMenuGroup {
  title: string
  open: boolean
  key: string
  icon: string
  group: IMenuGroupItem[]
}

const menuGroup: IMenuGroup[] = [
  {
    title: '机器管理',
    open: true,
    key: 'machine',
    icon: 'cluster',
    group: [
      {
        key: 'machine_list',
        path: '/machine/list',
        icon: 'desktop',
        title: '机器列表',
      },
    ],
  },
  {
    title: '交易管理',
    open: true,
    key: 'market',
    icon: 'deployment-unit',
    group: [
      {
        key: 'instance_list',
        path: '/market/instance/list',
        icon: 'apartment',
        title: '实例列表',
      },
    ],
  },
  {
    title: '用户管理',
    open: false,
    key: 'user',
    icon: 'user',
    group: [
      {
        key: 'user_list',
        path: '/user/list',
        icon: 'team',
        title: '用户列表',
      },
      {
        key: 'audit_list',
        path: '/user/audit/list',
        icon: 'audit',
        title: '审核列表',
      },
    ],
  },
  {
    title: '市场管理',
    open: true,
    key: 'shop',
    icon: 'shop',
    group: [
      {
        key: 'shelf_list',
        path: '/shop/shelf/list',
        icon: 'container',
        title: '货架管理',
      },
    ],
  },
  {
    title: '财务管理',
    open: true,
    key: 'accounting',
    icon: 'account-book',
    group: [
      {
        key: 'recharge_list',
        path: '/accounting/recharge/list',
        icon: 'money-collect',
        title: '充值列表',
      },
      {
        key: 'order_list',
        path: '/accounting/order/list',
        icon: 'profile',
        title: '订单列表',
      },
    ],
  },
]

export default menuGroup
